import React, { useEffect, useRef } from "react";
import { Iconography, IconographySizes, Loader, LoaderSizes } from "@hid-galaxy-ui/galaxy-react";
import Message, { Message as MessageType } from "../Message";
import "./MessageList.scss";

interface MessageListProps {
  messages: MessageType[];
  isLoadingHistory?: boolean;
}

const MessageList: React.FC<MessageListProps> = ({ messages, isLoadingHistory = false }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <div className="message-list" ref={containerRef}>
      {isLoadingHistory ? (
        <div className="message-list-loading">
          <Loader variant={LoaderSizes.medium} />
        </div>
      ) : messages.length === 0 ? (
        <div className="message-list-empty">
          <Iconography
            icon="circleArrowRight"
            size={IconographySizes.Large}
          />
          <p>No messages yet. Start a conversation!</p>
        </div>
      ) : (
        <div className="message-list-content">
          {messages.map((message) => (
            <Message key={message.id} message={message} />
          ))}
          <div ref={messagesEndRef} />
        </div>
      )}
    </div>
  );
};

export default MessageList;

